module.exports = __webpack_public_path__ + "images/backgrounds/rain/full.2e8209ee9f21d7147a24.jpg";